import axios from '../api/axios';

export async function getTags(options) {
  const res = await axios.get(`/tags`, options);

  return res.data;
}
export async function createTag(body) {
  const response = await axios.post('/tags', JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function updateTag(tagId, body) {
  const response = await axios.patch(`/tags/${tagId}`, JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function deleteTag(tagId) {
  const response = await axios.delete(`/tags/${tagId}`);
  return response;
}
